import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ManualInvoicesRaw = React.lazy(() => import(/* webpackChunkName: "ManualInvoices" */ './ManualInvoices'));
export const ManualInvoices = () => (React.createElement(Page, { title: "View manual client payments", description: "View manual client payments" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ManualInvoicesRaw, null)))));
